import { HttpClient } from '@angular/common/http';
import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DataTableDirective } from 'angular-datatables';
import { strictEqual } from 'assert';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { DataTablesResponseViewModel } from '../../models/data-tables-response-view-model';
import { MerchantSignedUpViewModel } from '../../models/merchants-sign-up-view-model';
import { TerminalDTViewModel } from '../../models/terminal-dt-view-model';
import { ConfirmationDialogComponent } from '../../partials/confirmation-dialog/confirmation-dialog.component';
import { AuthenticationService } from '../../services/authentication.service';
import { PermissionEnum } from '../../services/guards/permissions';
import { TerminalService } from '../../services/terminal.service';
import { UserDataStoreService } from '../../services/user-data-store.service';

@Component({
  selector: 'app-merchant-terminal-staging',
  templateUrl: './merchant-terminal-staging.component.html',
  styleUrls: ['./merchant-terminal-staging.component.scss']
})
export class MerchantTerminalStagingComponent implements OnInit, OnDestroy {

  @ViewChild(DataTableDirective, { static: false })
  dataTableElement: DataTableDirective;
  public dtElement: DataTableDirective;

  public canManage = false;
  public raiseDanger: boolean = false;
  public raiseWarning: boolean = false;
  public success: boolean = false;
  public message: string;
  public danger: string;
  public warning: string;
  public canView: boolean;
  public merchantNumber = '';


  public merchantsSignUp: MerchantSignedUpViewModel[] = [];
  public merchantsSignUpDefault: MerchantSignedUpViewModel[] = [];
  public newMerchantsSignUp: MerchantSignedUpViewModel[] = [];
  public MerchantsSignUpOnPrep: MerchantSignedUpViewModel[] = [];
  public ConfigurationComplete: MerchantSignedUpViewModel[] = [];
  public dispatched: MerchantSignedUpViewModel[] = [];
  private _destroyed$ = new Subject<any>();
  private searchEndpoint = `${environment.apiUrl}/api/merchant/merchantSignUp/`;

  public searchDebounce = new Subject<string>();
  //public dtElement: DataTableDirective;
  public canEditMerchantSignUp: boolean;


  public merchantIdSearch = '';
  public shopNameSearch = '';
  public trackingId = '';
  public EditButton: string;
  public EditView: string;

  dtTrigger: Subject<any> = new Subject<any>();
  private refreshInterval: any;
  private unsubscribe: Subject<void> = new Subject<void>();

  constructor(private _httpClient: HttpClient,
    private _route: ActivatedRoute,
    private _router: Router,
    private _userDataStore: UserDataStoreService,
    private _authenticationService: AuthenticationService,
    private _modalService: NgbModal,
    private _terminalService: TerminalService,
    private _toastService: ToastrService,
    private _ngxUiLoaderService: NgxUiLoaderService,
    private cdr: ChangeDetectorRef) {

    this._route.params.pipe(takeUntil(this._destroyed$)).subscribe(async params => {

      this.canManage = this._userDataStore.hasRequiredPermissions([PermissionEnum.ViewMerchantSignUp]);
      if (!this.canManage) {
        this._toastService.warning("You do not have the required permissions to view this page, Please contact your system administrator", "Warning");
        this._router.navigate(['/']);
      }

      this.canEditMerchantSignUp = this._userDataStore.hasRequiredPermissions([PermissionEnum.EditMerchantSignUp]);


      if (params.id != '' && params.id != undefined) {
        this.merchantNumber = params.id;
      }

    });

    this.searchDebounce.pipe(
      debounceTime(800),
      distinctUntilChanged())
      .subscribe(async value => {
        await this.refreshTable();
      });

    //// Refresh the DataTable every 2 minutes interval
    //this.refreshInterval = setInterval(() => {
    //  this.refreshDataTable();
    //}, 2 * 60 * 1000); // 2 minutes

  }

  ngOnInit() {

  }

  public columns: any[] = [
    { data: 'merchantNumber', title: 'New merchant request', visible: true, searchable: true, search: { value: this.merchantIdSearch, regex: true } },
    { data: 'shopName', title: 'Terminal preparation', visible: true, searchable: true, search: { value: this.shopNameSearch, regex: true } },
    { data: 'changedBy', title: 'Configuration complete', visible: true, searchable: true, search: { value: this.shopNameSearch, regex: true } },
    { data: 'changedOn', title: 'Dispatched', visible: true, searchable: true, search: { value: this.shopNameSearch, regex: true } }
  ];

  public async ngAfterViewInit(): Promise<void> {
    this.dtTrigger.next();
    // await this.init();
  }

  private resetDatatable(): void {

    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      // Destroy the table first
      dtInstance.destroy();
      // Call the dtTrigger to rerender again
      this.dtTrigger.next();
    });

  }

  private async refreshTable(): Promise<void> {
    await this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      // Destroy the table first
      dtInstance.destroy();
      this.setupFilters();
      // Call the dtTrigger to rerender again
      this.dtTrigger.next();
    });
  }

  public setupFilters(): void {
    const searchColumns = this.columns.map((col) => {
      if (!!(col).search) {
        return { search: (col).search.value, regex: (col).search.regex };
      } else {
        return null;
      }
    });
    //this.dtOptions.searchCols = searchColumns;
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      let i = 0;
      for (const item of searchColumns) {
        if (item) {
          dtInstance.column(i).search(item.search, item.regex);
        }
        i++;
      }
    })
  }
  
  private searchColumns = this.columns.map((col) => {
    if (!!col.search) {
      return { search: col.search.value, regex: col.search.regex };
    } else {
      return null;
    }
  });

  public dtOptions: DataTables.Settings = {
    pageLength: 10,
    serverSide: true,
    processing: true,
    ajax: (dataTablesParameters: any, callback) => {
      this._httpClient
        .post<DataTablesResponseViewModel>(
          this.getUrl(),
          dataTablesParameters, {}
        ).subscribe(resp => {
          this._ngxUiLoaderService.start();
          this.merchantsSignUp = resp.data;
          if (this.merchantsSignUp != undefined) {

            if (this.merchantsSignUp.length <= 1) {
              this.merchantsSignUpDefault = this.merchantsSignUp;
            } else{
              this.merchantsSignUpDefault[0] = this.merchantsSignUp[0];//.filter(p => p.id === 1);
            }

            this.newMerchantsSignUp = this.merchantsSignUp.filter(p => p.status === "New").sort((a, b) => {
              const dateA = new Date(a.changedOn);
              const dateB = new Date(b.changedOn);
              // Compare dates in descending order
              return dateB.getTime() - dateA.getTime();
            });
            this.MerchantsSignUpOnPrep = this.merchantsSignUp.filter(p => p.status === "Terminal preparation").sort((a, b) => {
              const dateA = new Date(a.changedOn);
              const dateB = new Date(b.changedOn);
              // Compare dates in descending order
              return dateB.getTime() - dateA.getTime();
            });
            this.ConfigurationComplete = this.merchantsSignUp.filter(p => p.status === "Configuration complete").sort((a, b) => {
              const dateA = new Date(a.changedOn);
              const dateB = new Date(b.changedOn);
              // Compare dates in descending order
              return dateB.getTime() - dateA.getTime();
            });
            this.dispatched = this.merchantsSignUp.filter(p => p.status === "Dispatched").sort((a, b) => {
              const dateA = new Date(a.changedOn);
              const dateB = new Date(b.changedOn);
              // Compare dates in descending order
              return dateB.getTime() - dateA.getTime();
            });
          }
          this._ngxUiLoaderService.stop();

          callback({
            recordsTotal: resp.recordsTotal,
            recordsFiltered: resp.recordsFiltered,
            data: []
          });
        });
    },
    columns: this.columns,
    searchCols: this.searchColumns
  };

  public getUrl(): string {

    if (this.merchantNumber == '')
      return this.searchEndpoint;
    else
      return this.searchEndpoint + this.merchantNumber
  }

  public get displayColumns() {
    return this.dtOptions.columns.filter(x => x.visible != false);
  }

  ngOnDestroy(): void {
    // Clear the interval and unsubscribe from observables to prevent memory leaks

    this.dtTrigger.unsubscribe();
    clearInterval(this.refreshInterval);
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  public async editTerminal(merchant: MerchantSignedUpViewModel): Promise<void> {
    this._router.navigate(['management', 'terminals-configuration', merchant.merchantNumber]);
  }

  public inUseBy(terminal: MerchantSignedUpViewModel): string {
    if (terminal?.inUseBy == this._userDataStore.currentUserValue.id || terminal.status == "New") {
      return "Configure terminals";
    }
    return "View terminals";//#6293bb
  }
  public async viewTerminals(merchant: MerchantSignedUpViewModel): Promise<void> {

    this._ngxUiLoaderService.start();
    var terminalDetails = await this._terminalService.GetTerminalsByMerchantNumber(merchant.merchantNumber);
    var tids = terminalDetails["result"].map(td => 'TID: ' + td.id)
    this.openUsedDeleteFailureConfirmationDialog(tids, merchant.merchantNumber);

    this._ngxUiLoaderService.stop();

  }

  public async openUsedDeleteFailureConfirmationDialog(terminals: string[], merchant: string) {

    var message = "<b>MID :</b>" + merchant + "</b>";
    message += "<br/><br/><b>TID :</b>"

    const dialogRef = this._modalService.open(ConfirmationDialogComponent, {
      windowClass: 'modal-fade-in',
      centered: false,
      size: 'xl',
      backdrop: 'static'
    });
    dialogRef.componentInstance.acceptButtonText = "OK"
    dialogRef.componentInstance.title = "Terminals"
    dialogRef.componentInstance.message = message;
    dialogRef.componentInstance.listMessage = terminals;
    dialogRef.componentInstance.listMessageHtml;
  }



  public backgroudColor(terminal: MerchantSignedUpViewModel): string {

    if (terminal?.inUseBy == this._userDataStore.currentUserValue.id) {
      return "style='!background-color: red; border-color:red'";
    }
    else if (terminal.status == "New") {
      return "style='!background-color: red; border-color:red";
    }
    return "style='background-color: #6293bb'; border-color:#6293bb";//
  }
}


